import React, { useRef } from "react";
import { useEffect, useContext } from "react";
import BruttoNettoContext from "../../BruttoNettoRechnerKomponenten/BruttoNettoContext";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function ErgJaHo() {
  const { bruttoNettoState, handleBruttoNettoState } =
    useContext(BruttoNettoContext);
  const nettoGehalt = bruttoNettoState.nettoGehalt;
  const safeHandleBruttoNettoState = useRef(handleBruttoNettoState);
  useEffect(() => {
    console.log("useEffect running");

    const abgabenBerechnen = () => {
      let ergJaHoNetto = (
        bruttoNettoState.nettoGehalt * 12 +
        parseFloat(bruttoNettoState.nettoSZ13) +
        parseFloat(bruttoNettoState.nettoSZ14)
      ).toFixed(2);
      safeHandleBruttoNettoState.current("ergJaHoNetto", ergJaHoNetto);

      let ergJaHoBrutto =
        bruttoNettoState.ergDGgesamt * 14 + bruttoNettoState.bruttoGehalt * 14;

      safeHandleBruttoNettoState.current("ergJaHoBrutto", ergJaHoBrutto);

      //   safeHandleBruttoNettoState.current("steuer", gesamtSteuer.toFixed(2));
      //   safeHandleBruttoNettoState.current("sVsgBeitrag", sVsgBeitrag.toFixed(2));
      //   safeHandleBruttoNettoState.current("sVsgSatz", sVsgSatz.toFixed(2));
      //   safeHandleBruttoNettoState.current("nettoGehalt", nettoGehalt.toFixed(2));
    };

    abgabenBerechnen();
  }, [nettoGehalt, safeHandleBruttoNettoState]);
  return (
    <div style={{ "margin-top": "3.36rem" }}>
      <p className="lead">
        <b>Jahreshochrechnung</b>
      </p>
      <div className="net-pay trc2 result">
        DN netto{" "}
        <span className="tooltip" data-tooltip-id="tooltip14">
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.ergJaHoNetto.toLocaleString("de-DE", {
            maximumFractionDigits: 2,
          })}
          €
        </span>
      </div>
      <div className="net-cost trc1 result">
        DG brutto{" "}
        <span className="tooltip" data-tooltip-id="tooltip15">
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.ergJaHoBrutto.toLocaleString("de-DE", {
            maximumFractionDigits: 2,
          })}
          €
        </span>
      </div>
      <ReactTooltip id="tooltip14" place="bottom" variant="info">
        <p>12 mal lfd. Monatslohn + SZ, jeweils netto.</p>
      </ReactTooltip>
      <ReactTooltip id="tooltip15" place="bottom" variant="info">
        <p>
          <p>14 Monatslöhne + 14 Zuschläge. </p>
          <p>Zuschläge mit KF-Rabatt.</p>
          <p>Lohnsumme sonstiger DN kann zu Entfall des KFR führen.</p>
        </p>
      </ReactTooltip>
    </div>
  );
}
